import { createReducer } from '@reduxjs/toolkit';
import { SmoMoonType } from '../../../../Models/Smo/SmoMoonType';
import { Optional } from '../../../../Utils/Types';
import DebugActions from '../Debug/DebugActions';
import VideoStoreActions from '../Video/VideoStoreActions';
import VideoAnalysisActions from './VideoAnalysisActions';
import { VideoAnalysisState } from './VideoAnalysisState';

const initialFilterBrightness: Record<SmoMoonType, { value: Optional<number>; comparisonMisMatchPercent: number }> = {
  [SmoMoonType.single]: { value: undefined, comparisonMisMatchPercent: 100 },
  [SmoMoonType.story]: { value: undefined, comparisonMisMatchPercent: 100 },
  [SmoMoonType.multi]: { value: undefined, comparisonMisMatchPercent: 100 }
};
const initialState: VideoAnalysisState = {
  filterBrightness: initialFilterBrightness
};
export const videoAnalysisReducer = createReducer(initialState, (builder) => {
  builder.addCase(VideoAnalysisActions.setPredictedEnvironment, (state, action) => ({
    ...state,
    predictedEnvironment: action.payload
  }));
  builder.addCase(VideoAnalysisActions.setPredictedMoonName, (state, action) => ({
    ...state,
    predictedMoonName: action.payload
  }));
  builder.addCase(VideoAnalysisActions.setFilterBrightness, (state, action) =>
    action.payload.comparisonMisMatchPercent <=
    state.filterBrightness[action.payload.moonType].comparisonMisMatchPercent
      ? {
          ...state,
          filterBrightness: {
            ...state.filterBrightness,
            [action.payload.moonType]: {
              value: action.payload.brightness,
              comparisonMisMatchPercent: action.payload.comparisonMisMatchPercent
            }
          }
        }
      : state
  );
  builder.addCase(VideoStoreActions.setVideoSource, (state) => ({
    ...state,
    filterBrightness: initialFilterBrightness
  }));
  builder.addCase(VideoAnalysisActions.resetFilterBrightness, (state) => ({
    ...state,
    filterBrightness: initialFilterBrightness
  }));
  builder.addCase(DebugActions.updateFilterBrightness, (state, action) => ({
    ...state,
    filterBrightness: {
      ...state.filterBrightness,
      [action.payload.moonType]: {
        value: action.payload.brightness,
        comparisonMisMatchPercent: 0
      }
    }
  }));
});
